import type { Messages } from '@/i18n/messages/en/index.ts'

/**
 * Portuguese is declared `: Messages['common']`, never inferred. That is the whole
 * completeness guarantee (PRD-27 LOC-011): a key missing here, a key that exists here and
 * not in English, or a function whose signature drifted, is a `bun run typecheck` failure.
 *
 * Register is `você`, informal-professional (LOC-061) — the way Brazilian product copy is
 * actually written. No `o senhor`, and no Portuguese-from-Portugal spellings.
 */
export const common: Messages['common'] = {
  language: 'Idioma',
  languageNameEn: 'English',
  languageNamePt: 'Português (Brasil)',

  justNow: 'agora mesmo',
  expired: 'expirado',
  inUnderAMinute: 'em menos de um minuto',
  never: 'nunca',

  close: 'Fechar',
  cancel: 'Cancelar',
  save: 'Salvar',
  saving: 'Salvando…',
  saved: 'Salvo',
  edit: 'Editar',
  remove: 'Remover',
  delete: 'Excluir',
  confirm: 'Confirmar',
  back: 'Voltar',
  next: 'Avançar',
  done: 'Concluído',
  copy: 'Copiar',
  copied: 'Copiado',
  search: 'Buscar',
  clear: 'Limpar',
  showMore: 'Mostrar mais',
  showLess: 'Mostrar menos',

  loading: 'Carregando…',
  retry: 'Tentar novamente',
  none: '—',

  andMore: (count) => `+${count} mais`,

  sessionExpired: 'Sua sessão terminou. Entre novamente para continuar.',
  connectionLost: 'A conexão com o assistente foi perdida.',
  genericError: 'Algo deu errado.',
  requestFailed: (status) => `A solicitação falhou (${status}).`
}
